import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConfigService } from 'src/app/services/app-config.service';
import { SearchManagerUser } from './manage-users/manage-users.component';
import { Observable } from 'rxjs';
import { GestionnaireCreate } from 'src/app/models/gestionnaireCreate';
import { GestionnaireUpdate } from 'src/app/models/gestionnaireUpdate';

@Injectable({
  providedIn: 'root'
})
export class ManagerUsersService {

  private apiUrl: string;
  private apiEndpoint: string;

  constructor(private _http: HttpClient, private _appConfig: AppConfigService) {
      this.apiUrl = _appConfig.config.servicesBaseUrl;
      this.apiEndpoint = this.apiUrl + "/adm/manager-users";
  }

  getManagerUser(managerUserKey: string): Observable<any> {
    return this._http.get<any>(this.apiEndpoint + "/" + managerUserKey);
  }

  findManagerUsers(searchManagerUser: SearchManagerUser,  page: number, size: number, sortBy:string, order: string): Observable<any> {
    let url = `${this.apiEndpoint}/search?page=${page}&size=${size}&sortBy=${sortBy}&order=${order.toUpperCase()}`;
    return this._http.post<any>(url, searchManagerUser);
  }

  updateManagerUser(gestionnaire: GestionnaireUpdate) {
    return this._http.put<any>(this.apiEndpoint + "/", gestionnaire);
  }

  createManagerUser(gestionnaire: GestionnaireCreate) {
    return this._http.post<any>(this.apiEndpoint+ "/", gestionnaire);
  }

  enable(compteKey: number, enable: boolean) {
    if(enable) {
      return this._http.put(this.apiEndpoint + '/enable/' + compteKey, null);
    } 
    return this._http.put(this.apiEndpoint + '/disable/' + compteKey, null);
  }

  resetPassword(managerUserKey: number) {
    return this._http.put<any>(this.apiEndpoint + '/reset-password/' + managerUserKey, null);
  }

}
